export default (array) => {
    return array.reduce((previousVal, current) => {
        const { id, name } = current;
        return { ...previousVal, [id]: { id, name, active: false } };
    }, {})
}